// fields/renderTextField.tsx
import { Grid, TextField, InputAdornment, IconButton, Button } from "@mui/material";
import { Clear, Search } from "@mui/icons-material";
import React from "react";
import { ToolbarFieldConfig, TFilterFieldsLocal } from "../ToolbarSinisterGeneric";

type Props = {
	field: ToolbarFieldConfig;
	filters: TFilterFieldsLocal;
	setFilter: (key: string, value: any) => void;
	handleSearch: () => void;
	handleClear: (key: string) => void;
};

export function renderTextField({ field, filters, setFilter, handleSearch, handleClear }: Props) {
	const value = filters[field.key] ?? "";

	return (
		<React.Fragment key={field.key}>
			<Grid item>
				<TextField
					label={field.label}
					size="small"
					value={value}
					onChange={(e) => {
						setFilter(field.key, e.target.value);
						field.onChange?.(e.target.value, filters, setFilter);
					}}
					onKeyDown={(e) => {
						if (e.key === "Enter") {
							e.preventDefault();
							handleSearch();
						}
					}}
					InputProps={{
						endAdornment: value && (
							<InputAdornment position="end">
								<IconButton size="small" onClick={() => handleClear(field.key)}>
									<Clear fontSize="small" />
								</IconButton>
							</InputAdornment>
						),
					}}
					{...field.extraProps}
				/>
			</Grid>
			<Grid item>
				<Button onClick={handleSearch} variant="contained" size="small" startIcon={<Search />} sx={{ height: 40, px: 2 }}>
					{value ? "Pesquisar" : "Filtrar"}
				</Button>
			</Grid>
		</React.Fragment>
	);
}
